import script from "./Page6.vue?vue&type=script&setup=true&lang=js"
export * from "./Page6.vue?vue&type=script&setup=true&lang=js"

import "./Page6.vue?vue&type=style&index=0&id=8ee23164&lang=less"

const __exports__ = script;

export default __exports__